import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";


export class FreespinIntro implements SimplePresentation {

    name:string = "FreespinIntro";


    constructor() {

    }

    public shouldRun():boolean {
        return DevilsCrossRoad.model.data.mode != GameMode.FREESPIN && DevilsCrossRoad.model.data.nextMode == DevilsCrossRoadGameMode.FREESPIN;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();

        DevilsCrossRoad.autoPlayPlugin.turnOffAutoplayOnBonus();

        tl.add(()=>{
            DevilsCrossRoadSound.switchMusic({name:DevilsCrossRoadSound.getMusicNameByMode(DevilsCrossRoadSound.FS_INTRO_MUSIC)});
        });
        tl.add(DevilsCrossRoad.transitionScreenView.showIntro());
        tl.add(DevilsCrossRoad.transitionScreenView.enableButton(() => this.onButtonClick(controller)));
        tl.add(DevilsCrossRoad.keypadPlugin.hide(0.1),0);
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            DevilsCrossRoadSound.switchMusic({name:DevilsCrossRoadSound.getMusicNameByMode(DevilsCrossRoad.model.data.nextMode)});
            DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(DevilsCrossRoad.model.data.freespinsLeft);
            DevilsCrossRoad.freespinUnlockAreas.setIndicator(DevilsCrossRoad.model.data.freespinsLeft);
            DevilsCrossRoad.keypadPlugin.show(0.1);
            DevilsCrossRoad.LANDED_STICKYS_IDS = [];
        });

        tl.add(DevilsCrossRoad.transitionScreenView.hideIntro());


        tl.add(() => controller.finish());
    }

}